import React from "react";

export default function ButtonGroup({
  selectedIdx,
  onClick,
  fullWidth = true,
}: {
  selectedIdx: number;
  onClick: (idx: number) => void;
  /** false hugs the two labels instead of stretching across the container. */
  fullWidth?: boolean;
}) {
  const selectedClasses = "text-primary-700 bg-primary-100";
  const unselectedClasses = "text-neutral-800 bg-white";

  return (
    <div className={`${fullWidth ? "w-full" : ""} isolate inline-flex rounded-md shadow-sm`}>
      <button
        type="button"
        className={`relative ${
          fullWidth ? "flex-1" : ""
        } items-center rounded-l-md px-4 py-2 text-sm font-medium ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 ${
          selectedIdx === 0 ? selectedClasses : unselectedClasses
        }`}
        onClick={() => {
          if (selectedIdx === 0) return;
          onClick(0);
        }}
      >
        Retention Policy Builder
      </button>
      <button
        type="button"
        className={`relative -ml-px ${
          fullWidth ? "flex-1" : ""
        } items-center rounded-r-md px-4 py-2 text-sm font-medium ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 ${
          selectedIdx === 1 ? selectedClasses : unselectedClasses
        }`}
        onClick={() => {
          if (selectedIdx === 1) return;
          onClick(1);
        }}
      >
        Add Your Own
      </button>
    </div>
  );
}
